import { Box } from '@mui/material';

import PaymentOverview from './PaymentOverview';
import PayorResponsibility from './PayorResponsibility';

function ClaimPayments() {
  return (
    <Box>
      <PaymentOverview />
      <PayorResponsibility />
    </Box>
  );
}

export default ClaimPayments;
